export default __webpack_public_path__ + "static/media/banner2.53c58867.png";